// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1A2Jw","rightAdornment":"Header_rightAdornment__1cTXC"};